import React from 'react'
import { useStyles } from './FlyOutImpressions.styles'
import { useSelector } from '../../../store'
import { MetricsData } from '../../../modules/storefrontMetrics/reducer'

import { DisplayCard } from '@labrav/react-components'
import { PercentageUpDownType } from '@labrav/react-components/lib/@types/v2/components/PercentageUpDown'

export const FlyOutImpressions: React.FC = () => {
  const { classes } = useStyles()
  const { impressionCount } = useSelector<MetricsData>(
    state => state.storefrontMetricsData
  )
  const updatedImpressionCount = impressionCount.filter(item =>
    [
      'total_impression',
      'unique_impression',
      'clicks',
      'form_submission',
    ].includes(item.key as string)
  )
  return (
    <div data-testid="impressions-section" className={classes.cardsRoot}>
      {updatedImpressionCount.map(data => (
        <DisplayCard
          number={data.totalCount as number}
          percentage={{
            percentage: parseFloat(data?.percentage?.toFixed(2) as string),
            isPercentage: true,
            type: getPercentageType(data.percentage as number),
          }}
          subTitle={getFormattedLabel(data.key as string)}
          info={{
            label: getFormattedLabel(data.key as string),
            description: 'This represents the total monthly growth.',
          }}
        />
      ))}
    </div>
  )
}

export const getFormattedLabel = (key: string): string => {
  const labelMap: Record<string, string> = {
    total_impression: 'Total Impressions',
    unique_impression: 'Unique Impressions',
    clicks: 'Clicks',
    form_submission: 'Form submissions',
    BUY_WITH_AWS: 'Buy with AWS',
    OPEN_LISTING: 'View on AWS Marketplace',
    FREE_TRIAL: 'Try for free',
    REQUEST_A_PRIVATE_OFFER: 'Request a private offer',
    REQUEST_A_DEMO: 'Request a demo',
    total_clicks: 'Total clicks',
    unique_button_clicked: 'Unique button clicked',
    Unique_form_submissions: 'Unique form submissions',
    converted: 'Converted',
    DEMO_FORM: 'Demo form',
    PRIVATE_OFFER_FORM: 'Private offer form',
  }
  return labelMap[key] || key
}
export const getPercentageType = (percentage: number): PercentageUpDownType => {
  if (percentage > 0) return 'up'
  if (percentage < 0) return 'down'
  return 'right'
}
